import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LineMapIcon from 'components/Luxkit/Icons/line/LineMapIcon'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import LinePlaneDepartureIcon from 'components/Luxkit/Icons/line/LinePlaneDepartureIcon'
import LineRestaurantIcon from 'components/Luxkit/Icons/line/LineRestaurantIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${rem(8)};
  margin-bottom: ${rem(32)};
  margin-top: ${rem(20)};
`

const FeatureContainer = styled(Group)`
  width: ${rem(148)};
`

function FirstTime() {
  return (
    <Container>
      <Group direction="vertical" gap={20}>
        <BodyText variant="large" weight="bold">
          What are trip plans?
        </BodyText>
        <BodyText variant="large">
          'Trip plans' are how we group your saved offers. By doing so, we
          enable you to collect your favourite Luxury Escapes offers, organise
          them by trip, and easily plan your next adventure.
        </BodyText>
        <Group direction="vertical" smDirection="horizontal" gap={24}>
          <Group direction="horizontal" gap={24}>
            <FeatureContainer direction="vertical" gap={12}>
              <LineMapMarkerIcon size="L" />
              <BodyText variant="medium">
                Add places from anywhere on the web
              </BodyText>
            </FeatureContainer>
            <FeatureContainer direction="vertical" gap={12}>
              <LineMapIcon size="L" />
              <BodyText variant="medium">
                Map it out and visualise your itinerary
              </BodyText>
            </FeatureContainer>
          </Group>
          <Group direction="horizontal" gap={24}>
            <FeatureContainer direction="vertical" gap={12}>
              <LineRestaurantIcon size="L" />
              <BodyText variant="medium">
                Discover top local attractions
              </BodyText>
            </FeatureContainer>
            <FeatureContainer direction="vertical" gap={12}>
              <LinePlaneDepartureIcon size="L" />
              <BodyText variant="medium">
                Book flights, hotels, car hire & more
              </BodyText>
            </FeatureContainer>
          </Group>
        </Group>
      </Group>
    </Container>
  )
}

export default FirstTime
